/**
 * Demo Data for FaithYoke Admin Web
 *
 * This file contains sample data that matches the mobile app screenshots
 * for marketing and demonstration purposes.
 *
 * To enable demo mode: Set localStorage.setItem('demoMode', 'true')
 * To disable demo mode: localStorage.removeItem('demoMode')
 */

// ============================================
// MEMBERS DATA
// ============================================
export interface DemoMember {
  id: string
  preferred_name: string
  first_name: string
  last_name: string
  email: string
  phone: string
  address: string
  created_at: string
  role: string
  ministry: string
  status: 'Active' | 'Inactive' | 'Visitor'
  last_attendance: string
  profile_image?: string
}

export const demoMembers: DemoMember[] = [
  {
    id: 'demo-1',
    preferred_name: 'David Chen',
    first_name: 'David',
    last_name: 'Chen',
    email: 'david.chen@email.com',
    phone: '+254 712 345 678',
    address: 'Nairobi, Kenya',
    created_at: '2024-01-15T10:00:00Z',
    role: 'Member',
    ministry: 'Youth Ministry',
    status: 'Active',
    last_attendance: '2024-10-20T09:00:00Z'
  },
  {
    id: 'demo-2',
    preferred_name: 'Sarah Miller',
    first_name: 'Sarah',
    last_name: 'Miller',
    email: 'sarah.miller@email.com',
    phone: '+254 722 456 789',
    address: 'Nairobi, Kenya',
    created_at: '2023-06-20T10:00:00Z',
    role: 'Member',
    ministry: 'Prayer Team',
    status: 'Active',
    last_attendance: '2024-10-20T09:00:00Z'
  },
  {
    id: 'demo-3',
    preferred_name: 'Michael C.',
    first_name: 'Michael',
    last_name: 'Carter',
    email: 'michael.carter@email.com',
    phone: '+254 733 567 890',
    address: 'Mombasa, Kenya',
    created_at: '2023-11-10T10:00:00Z',
    role: 'Member',
    ministry: 'Music Ministry',
    status: 'Active',
    last_attendance: '2024-10-16T19:00:00Z'
  },
  {
    id: 'demo-4',
    preferred_name: 'Emily R.',
    first_name: 'Emily',
    last_name: 'Rodriguez',
    email: 'emily.rodriguez@email.com',
    phone: '+254 744 678 901',
    address: 'Kisumu, Kenya',
    created_at: '2024-03-05T10:00:00Z',
    role: 'Member',
    ministry: 'Children Ministry',
    status: 'Active',
    last_attendance: '2024-10-13T09:00:00Z'
  },
  {
    id: 'demo-5',
    preferred_name: 'Maria Garcia',
    first_name: 'Maria',
    last_name: 'Garcia',
    email: 'maria.garcia@email.com',
    phone: '+254 755 789 012',
    address: 'Nairobi, Kenya',
    created_at: '2023-08-22T10:00:00Z',
    role: 'Member',
    ministry: 'Outreach',
    status: 'Active',
    last_attendance: '2024-10-20T09:00:00Z'
  },
  {
    id: 'demo-6',
    preferred_name: 'Jordan Smith',
    first_name: 'Jordan',
    last_name: 'Smith',
    email: 'jordan.smith@email.com',
    phone: '+254 766 890 123',
    address: 'Nairobi, Kenya',
    created_at: '2024-05-15T10:00:00Z',
    role: 'Member',
    ministry: 'Evangelism',
    status: 'Active',
    last_attendance: '2024-10-20T09:00:00Z'
  },
  {
    id: 'demo-7',
    preferred_name: 'Sarah Jenkins',
    first_name: 'Sarah',
    last_name: 'Jenkins',
    email: 'sarah.jenkins@email.com',
    phone: '+254 777 901 234',
    address: 'Nakuru, Kenya',
    created_at: '2023-02-10T10:00:00Z',
    role: 'Leader',
    ministry: 'Evangelism',
    status: 'Active',
    last_attendance: '2024-10-20T09:00:00Z'
  },
  {
    id: 'demo-8',
    preferred_name: 'Michael B.',
    first_name: 'Michael',
    last_name: 'Brown',
    email: 'michael.brown@email.com',
    phone: '+254 788 012 345',
    address: 'Eldoret, Kenya',
    created_at: '2023-04-18T10:00:00Z',
    role: 'Member',
    ministry: 'Ushering',
    status: 'Active',
    last_attendance: '2024-10-20T09:00:00Z'
  },
  {
    id: 'demo-9',
    preferred_name: 'Sarah J.',
    first_name: 'Sarah',
    last_name: 'Johnson',
    email: 'sarah.j@email.com',
    phone: '+254 799 123 456',
    address: 'Nairobi, Kenya',
    created_at: '2024-07-20T10:00:00Z',
    role: 'Visitor',
    ministry: '',
    status: 'Visitor',
    last_attendance: '2024-10-13T09:00:00Z'
  },
  {
    id: 'demo-10',
    preferred_name: 'David L.',
    first_name: 'David',
    last_name: 'Lee',
    email: 'david.lee@email.com',
    phone: '+254 700 234 567',
    address: 'Nairobi, Kenya',
    created_at: '2024-09-01T10:00:00Z',
    role: 'Member',
    ministry: 'Prayer Team',
    status: 'Active',
    last_attendance: '2024-10-20T09:00:00Z'
  }
]

// ============================================
// EVENTS DATA
// ============================================
export interface DemoEvent {
  id: string
  title: string
  description: string
  start_datetime: string
  end_datetime: string
  location: string
  event_type: string
  capacity?: number
  registered?: number
}

export const demoEvents: DemoEvent[] = [
  {
    id: 'event-1',
    title: 'The Power of Forgiveness',
    description: 'Sunday Service with Pastor John Smith exploring the transformative power of forgiveness in our daily lives.',
    start_datetime: '2024-10-24T10:00:00Z',
    end_datetime: '2024-10-24T12:00:00Z',
    location: 'Main Sanctuary',
    event_type: 'Service',
    capacity: 500,
    registered: 342
  },
  {
    id: 'event-2',
    title: "Men's Breakfast",
    description: 'Monthly men\'s fellowship breakfast. Join us for food, fellowship, and discussion.',
    start_datetime: '2024-10-28T08:00:00Z',
    end_datetime: '2024-10-28T10:00:00Z',
    location: 'Fellowship Hall',
    event_type: 'Fellowship',
    capacity: 50,
    registered: 38
  },
  {
    id: 'event-3',
    title: 'Worship Night',
    description: 'An evening of worship and praise. Come as you are and experience God\'s presence.',
    start_datetime: '2024-11-05T19:00:00Z',
    end_datetime: '2024-11-05T21:00:00Z',
    location: 'Main Sanctuary',
    event_type: 'Worship',
    capacity: 400,
    registered: 156
  },
  {
    id: 'event-4',
    title: 'Youth Ski Trip Sign-ups',
    description: 'Limited spots available for our annual trip to the mountains. Sign up now!',
    start_datetime: '2024-12-15T06:00:00Z',
    end_datetime: '2024-12-17T20:00:00Z',
    location: 'Mountain Resort',
    event_type: 'Youth',
    capacity: 30,
    registered: 22
  },
  {
    id: 'event-5',
    title: 'Weekly Prayer Meeting',
    description: 'Our weekly prayer meeting is this Wednesday at 7 PM. All are welcome to join us in prayer.',
    start_datetime: '2024-10-30T19:00:00Z',
    end_datetime: '2024-10-30T20:30:00Z',
    location: 'Prayer Room',
    event_type: 'Prayer',
    capacity: 100,
    registered: 45
  }
]

// ============================================
// ANNOUNCEMENTS DATA
// ============================================
export interface DemoAnnouncement {
  id: string
  title: string
  content: string
  category: 'URGENT' | 'EVENT' | 'GENERAL' | 'COMMUNITY'
  created_at: string
  published: boolean
  author: string
}

export const demoAnnouncements: DemoAnnouncement[] = [
  {
    id: 'ann-1',
    title: 'Fall Festival - This Weekend!',
    content: 'Join us for our annual Fall Festival! There will be games, food, and fun for the whole family this Saturday & Sunday.',
    category: 'URGENT',
    created_at: '2024-10-26T10:00:00Z',
    published: true,
    author: 'Pastor John Smith'
  },
  {
    id: 'ann-2',
    title: 'Weekly Prayer Meeting',
    content: 'Our weekly prayer meeting is this Wednesday at 7 PM. All are welcome to join us in prayer.',
    category: 'EVENT',
    created_at: '2024-10-25T10:00:00Z',
    published: true,
    author: 'Prayer Team'
  },
  {
    id: 'ann-3',
    title: 'Youth Group Bake Sale',
    content: 'Support our youth group by purchasing some delicious baked goods after the service this Sunday.',
    category: 'GENERAL',
    created_at: '2024-10-24T10:00:00Z',
    published: true,
    author: 'Youth Ministry'
  },
  {
    id: 'ann-4',
    title: 'Community Food Drive',
    content: 'We\'re collecting non-perishable food items for the local food bank. Donations can be dropped off in the lobby.',
    category: 'COMMUNITY',
    created_at: '2024-10-22T10:00:00Z',
    published: true,
    author: 'Outreach Team'
  }
]

// ============================================
// PRAYER REQUESTS DATA
// ============================================
export interface DemoPrayerRequest {
  id: string
  title: string
  content: string
  member_id: string
  member_name: string
  created_at: string
  is_public: boolean
  prayer_count: number
  status: 'active' | 'answered' | 'closed'
}

export const demoPrayerRequests: DemoPrayerRequest[] = [
  {
    id: 'prayer-1',
    title: 'Surgery for my mother',
    content: 'Please pray for my mother, Helen, who is undergoing surgery tomorrow morning. We\'re praying for the surgeon\'s hands and for a peaceful recovery.',
    member_id: 'demo-2',
    member_name: 'Sarah Miller',
    created_at: '2024-10-24T08:00:00Z',
    is_public: true,
    prayer_count: 12,
    status: 'active'
  },
  {
    id: 'prayer-2',
    title: 'Job interview',
    content: 'Grateful for a successful job interview today! Praying for favor and that this opportunity aligns with God\'s plan for my family.',
    member_id: 'demo-1',
    member_name: 'David Chen',
    created_at: '2024-10-24T02:00:00Z',
    is_public: true,
    prayer_count: 35,
    status: 'active'
  },
  {
    id: 'prayer-3',
    title: 'Safe travels for mission trip',
    content: 'Asking for prayers for safe travels for my son, who is flying out for a mission trip this weekend.',
    member_id: 'demo-5',
    member_name: 'Maria Garcia',
    created_at: '2024-10-23T10:00:00Z',
    is_public: true,
    prayer_count: 58,
    status: 'active'
  }
]

// ============================================
// TESTIMONIES DATA
// ============================================
export interface DemoTestimony {
  id: string
  title: string
  content: string
  member_id: string
  member_name: string
  created_at: string
  likes: number
  featured: boolean
}

export const demoTestimonies: DemoTestimony[] = [
  {
    id: 'test-1',
    title: 'Healed After Months of Pain',
    content: 'After a long struggle, I found peace and healing through faith and the unwavering support of our church community.',
    member_id: 'demo-2',
    member_name: 'Sarah J.',
    created_at: '2024-10-22T10:00:00Z',
    likes: 45,
    featured: true
  },
  {
    id: 'test-2',
    title: 'Grateful for Support',
    content: 'Just wanted to share how grateful I am for the support. A huge thank you to the prayer team for their constant...',
    member_id: 'demo-10',
    member_name: 'David L.',
    created_at: '2024-10-21T10:00:00Z',
    likes: 32,
    featured: false
  },
  {
    id: 'test-3',
    title: 'Family Miracle',
    content: 'My family experienced a miracle this week and I had to share. God is faithful!',
    member_id: 'demo-5',
    member_name: 'Maria G.',
    created_at: '2024-10-19T10:00:00Z',
    likes: 67,
    featured: false
  },
  {
    id: 'test-4',
    title: 'Career Breakthrough',
    content: 'Praise God for His faithfulness in my career transition. After months of waiting...',
    member_id: 'demo-8',
    member_name: 'Michael B.',
    created_at: '2024-10-18T10:00:00Z',
    likes: 28,
    featured: false
  }
]

// ============================================
// GIVING/CONTRIBUTIONS DATA
// ============================================
export interface DemoContribution {
  id: string
  member_id: string
  member_name: string
  amount: number
  category: 'Tithe' | 'Offering' | 'Missions' | 'Building Fund'
  payment_method: 'Mobile Money' | 'Bank Card' | 'Bank Transfer' | 'Cash'
  created_at: string
  is_recurring: boolean
}

export const demoContributions: DemoContribution[] = [
  { id: 'give-1', member_id: 'demo-1', member_name: 'David Chen', amount: 150, category: 'Tithe', payment_method: 'Mobile Money', created_at: '2024-10-20T10:30:00Z', is_recurring: true },
  { id: 'give-2', member_id: 'demo-2', member_name: 'Sarah Miller', amount: 50, category: 'Offering', payment_method: 'Bank Card', created_at: '2024-10-20T10:45:00Z', is_recurring: false },
  { id: 'give-3', member_id: 'demo-5', member_name: 'Maria Garcia', amount: 200, category: 'Missions', payment_method: 'Mobile Money', created_at: '2024-10-20T11:00:00Z', is_recurring: true },
  { id: 'give-4', member_id: 'demo-7', member_name: 'Sarah Jenkins', amount: 100, category: 'Tithe', payment_method: 'Bank Transfer', created_at: '2024-10-19T09:15:00Z', is_recurring: true },
  { id: 'give-5', member_id: 'demo-3', member_name: 'Michael C.', amount: 75, category: 'Building Fund', payment_method: 'Mobile Money', created_at: '2024-10-19T14:30:00Z', is_recurring: false },
  { id: 'give-6', member_id: 'demo-8', member_name: 'Michael B.', amount: 250, category: 'Tithe', payment_method: 'Bank Card', created_at: '2024-10-18T10:00:00Z', is_recurring: true },
  { id: 'give-7', member_id: 'demo-4', member_name: 'Emily R.', amount: 30, category: 'Offering', payment_method: 'Cash', created_at: '2024-10-13T10:00:00Z', is_recurring: false },
]

// ============================================
// EVANGELISM DATA
// ============================================
export interface DemoEvangelismContact {
  id: string
  name: string
  stage: 'awareness' | 'interest' | 'decision' | 'growth' | 'believer' | 'baptized' | 'disciple'
  last_contact: string
  assigned_to: string
  notes: string
}

export const demoEvangelismContacts: DemoEvangelismContact[] = [
  { id: 'ev-1', name: 'Jordan Smith', stage: 'interest', last_contact: '2024-10-23T16:15:00Z', assigned_to: 'Sarah Jenkins', notes: 'Had a great conversation about faith' },
  { id: 'ev-2', name: 'Maria Garcia', stage: 'decision', last_contact: '2024-10-28T11:30:00Z', assigned_to: 'Michael B.', notes: 'Ready to commit' },
  { id: 'ev-3', name: 'David Chen', stage: 'awareness', last_contact: '2024-10-26T19:00:00Z', assigned_to: 'Sarah Jenkins', notes: 'First-time visitor' },
  { id: 'ev-4', name: 'Thomas Williams', stage: 'believer', last_contact: '2024-10-20T10:00:00Z', assigned_to: 'Michael B.', notes: 'Accepted Christ!' },
  { id: 'ev-5', name: 'Grace Otieno', stage: 'baptized', last_contact: '2024-10-15T10:00:00Z', assigned_to: 'Sarah Jenkins', notes: 'Baptized on Oct 15' },
]

export const demoEvangelismStats = {
  livesTouched: 142,
  newBelievers: 12,
  studiesStarted: 28,
  stages: {
    awareness: 56,
    interest: 32,
    decision: 18,
    growth: 12
  },
  teamLeaderboard: [
    { name: 'Sarah Jenkins', points: 1250 },
    { name: 'Michael B.', points: 1180 },
    { name: 'You', points: 970 }
  ]
}

// ============================================
// ATTENDANCE DATA
// ============================================
export interface DemoAttendance {
  id: string
  member_id: string
  member_name: string
  event_type: string
  created_at: string
}

export const demoAttendanceRecords: DemoAttendance[] = [
  { id: 'att-1', member_id: 'demo-1', member_name: 'David Chen', event_type: 'Sunday Service', created_at: '2024-10-20T09:00:00Z' },
  { id: 'att-2', member_id: 'demo-2', member_name: 'Sarah Miller', event_type: 'Sunday Service', created_at: '2024-10-20T09:00:00Z' },
  { id: 'att-3', member_id: 'demo-3', member_name: 'Michael C.', event_type: 'Midweek Study', created_at: '2024-10-16T19:00:00Z' },
  { id: 'att-4', member_id: 'demo-4', member_name: 'Emily R.', event_type: 'Sunday Service', created_at: '2024-10-13T09:00:00Z' },
  { id: 'att-5', member_id: 'demo-5', member_name: 'Maria Garcia', event_type: 'Sunday Service', created_at: '2024-10-20T09:00:00Z' },
]

export const demoAttendanceTrends = [
  { month: 'May', attendance: 145 },
  { month: 'Jun', attendance: 168 },
  { month: 'Jul', attendance: 152 },
  { month: 'Aug', attendance: 198 },
  { month: 'Sep', attendance: 210 },
  { month: 'Oct', attendance: 225 }
]

// ============================================
// FASTING DATA
// ============================================
export interface DemoFast {
  id: string
  name: string
  type: 'Daniel Fast' | 'Juice Fast' | 'Media Fast' | 'Water Fast'
  start_date: string
  end_date: string
  current_day: number
  total_days: number
  scripture: string
}

export const demoFasts: DemoFast[] = [
  {
    id: 'fast-1',
    name: 'Daniel Fast',
    type: 'Daniel Fast',
    start_date: '2024-10-19T00:00:00Z',
    end_date: '2024-11-08T00:00:00Z',
    current_day: 5,
    total_days: 21,
    scripture: '"He said to them, This kind can come out by nothing but prayer and fasting." - Mark 9:29'
  }
]

export const demoFastHistory = [
  { name: 'Daniel Fast', start_date: '2024-01-01', end_date: '2024-01-21', completed: true },
  { name: 'Media Fast', start_date: '2023-12-01', end_date: '2023-12-07', completed: true },
  { name: 'Juice Fast', start_date: '2023-11-10', end_date: '2023-11-12', completed: true }
]

// ============================================
// READING PLANS DATA
// ============================================
export interface DemoReadingPlan {
  id: string
  name: string
  progress: number
  days_remaining: number
  status: 'in_progress' | 'completed'
  completed_date?: string
}

export const demoReadingPlans: DemoReadingPlan[] = [
  { id: 'rp-1', name: 'The Gospels in 40 Days', progress: 25, days_remaining: 30, status: 'in_progress' },
  { id: 'rp-2', name: 'Old Testament Survey', progress: 50, days_remaining: 15, status: 'in_progress' },
  { id: 'rp-3', name: 'Proverbs: A Chapter a Day', progress: 100, days_remaining: 0, status: 'completed', completed_date: '2024-05-15' }
]

// ============================================
// DEVOTIONS DATA
// ============================================
export interface DemoDevotion {
  id: string
  title: string
  content: string
  scripture_reference: string
  author: string
  created_at: string
  prayer_points: string[]
}

export const demoDevotions: DemoDevotion[] = [
  {
    id: 'dev-1',
    title: 'Daily Encouragement',
    content: 'A short introductory paragraph summarizing the devotion\'s theme, inviting the reader to engage with the text. The main body of the devotion text begins here, offering spiritual insights and encouragement.',
    scripture_reference: 'John 3:16',
    author: 'Pastor John Smith',
    created_at: '2024-10-26T06:00:00Z',
    prayer_points: [
      'Pray for understanding and wisdom.',
      'Give thanks for the message received today.',
      'Ask for strength to apply this lesson to your life.'
    ]
  }
]

// ============================================
// DASHBOARD METRICS
// ============================================
export const demoDashboardMetrics = {
  totalMembers: 342,
  monthlyGiving: 15750,
  weeklyAttendance: 225,
  soulsWon: 12,
  memberGrowthRate: 8.5,
  givingGrowthRate: 12.3,
  attendanceGrowthRate: 5.2
}

export const demoGivingTrends = [
  { month: 'May', giving: 12500 },
  { month: 'Jun', giving: 13200 },
  { month: 'Jul', giving: 11800 },
  { month: 'Aug', giving: 14500 },
  { month: 'Sep', giving: 15200 },
  { month: 'Oct', giving: 15750 }
]

export const demoRecentActivities = [
  { type: 'member', message: 'Sarah J. joined the church', timestamp: '2024-10-24T14:30:00Z' },
  { type: 'giving', message: 'David Chen donated KES 15,000', timestamp: '2024-10-24T10:30:00Z' },
  { type: 'prayer', message: 'New prayer request: Surgery for my mother', timestamp: '2024-10-24T08:00:00Z' },
  { type: 'attendance', message: 'Maria Garcia checked in to service', timestamp: '2024-10-20T09:05:00Z' },
  { type: 'event', message: 'New event created: Fall Festival', timestamp: '2024-10-19T15:00:00Z' }
]

// ============================================
// DEMO MODE UTILITIES
// ============================================
export const DEMO_MODE_KEY = 'faithyoke_demo_mode'
export const DEMO_CHURCH_NAME = 'Grace Community Church'
export const DEMO_CURRENCY_SYMBOL = 'KES '

export function isDemoMode(): boolean {
  if (typeof window === 'undefined') return false
  return localStorage.getItem(DEMO_MODE_KEY) === 'true'
}

export function enableDemoMode(): void {
  localStorage.setItem(DEMO_MODE_KEY, 'true')
  window.location.reload()
}

export function disableDemoMode(): void {
  localStorage.removeItem(DEMO_MODE_KEY)
  window.location.reload()
}

export function toggleDemoMode(): void {
  if (isDemoMode()) {
    disableDemoMode()
  } else {
    enableDemoMode()
  }
}
